import { useEffect } from "react";
import { useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { setIsClientPortal } from "../slices/clientPortalSlice";
import { routes } from "../constants";
import { hasClientPortalAuth } from "../auth/authentication";

const isProd = process.env.REACT_APP_ENV === "production";
const useClientPortal = (): void => {
  const location = useLocation();
  const isClientPortal = location.pathname.includes(routes.clientPortal.name);
  const dispatch = useDispatch();
  const isClientPortalUser = hasClientPortalAuth();

  useEffect(() => {
    if (!isProd) {
      dispatch(setIsClientPortal(isClientPortal));
      if (isClientPortal || isClientPortalUser) {
        dispatch(push(`${routes.clientPortal.name}/${routes.clientPortal.subRoutes.login.name}`));
      }
    }
  }, [isClientPortal, dispatch, isClientPortalUser]);
};

export default useClientPortal;
